/** Hotkeys we care about when interacting with a dropdown */
export enum DropdownHotkey {
  ARROW_UP = 'arrow_up',
  ARROW_DOWN = 'arrow_down',
  HOME = 'home',
  END = 'end',
  ENTER = 'enter',
  ESCAPE = 'escape',
  TAB = 'tab',
  SPACE = 'space',
  SEARCH = 'search',
  UNSUPPORTED = 'unsupported',
}

export function keyEventToHotkey(e: KeyboardEvent): DropdownHotkey {
  switch (e.key) {
    case ' ':
    case 'Space':
      return DropdownHotkey.SPACE;
    case 'Enter':
      return DropdownHotkey.ENTER;
    case 'Escape':
      return DropdownHotkey.ESCAPE;
    case 'Tab':
      return DropdownHotkey.TAB;
    case 'ArrowDown':
      return DropdownHotkey.ARROW_DOWN;
    case 'ArrowUp':
      return DropdownHotkey.ARROW_UP;
    case 'Home':
      return DropdownHotkey.HOME;
    case 'End':
      return DropdownHotkey.END;
    default:
      if (e.key.match(/^[a-zA-Z0-9]$/)) {
        return DropdownHotkey.SEARCH;
      }
      return DropdownHotkey.UNSUPPORTED;
  }
}
